export default Object.freeze({
  swiper: 'swiper',
  grid: 'grid',
  list: 'list'
})
